import React from "react";
import Styles from "./AboutUs.module.css";

import { HashLink } from "react-router-hash-link";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Assyrian from "../assets/Images/AssyrianAboutus.png";
import GoToTop from "../components/GotoTop";

function AboutUs() {
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";
	return (
		<div className={Styles.container}>
			<GoToTop/>
			<div className={Styles.padding}></div>
			<img
				src={Assyrian}
				alt='Assyrian old'
				className={Styles.img}
			/>

			<div
				dir={isRtl ? "rtl" : "ltr"}
				className={Styles.aboutUs}
			>
				<h2 className={Styles.h2}>
					{t("Aboutus.titleWelcome")}
				</h2>

				<p className={Styles.p}>
					{t("Aboutus.paragraphWelcome")}{" "}
				</p>
				<h3 className={isRtl ? Styles.h3Rtl : Styles.h3}>
					{t("Aboutus.whyus")}
				</h3>

				<div>
					<p className={Styles.p}>
						<span>{t("Aboutus.t1")} </span>{" "}
						{t("Aboutus.t1Paragraph")}
					</p>
				</div>

				<div>
					<p className={Styles.p}>
						<span> {t("Aboutus.t2")}</span>{" "}
						{t("Aboutus.t2Paragraph")}
					</p>
				</div>

				<div>
					<p className={Styles.p}>
						<span>{t("Aboutus.t3")} </span>{" "}
						{t("Aboutus.t3Paragraph")}
					</p>
				</div>

				<div>
					<p className={Styles.p}>
						<span> {t("Aboutus.t4")} </span>{" "}
						{t("Aboutus.t4Paragraph")}
					</p>
				</div>

				<h3 className={isRtl ? Styles.h3Rtl : Styles.h3}>
					{t("Aboutus.titleMeetGuide")}
				</h3>

				<p className={Styles.p}>
					{t("Aboutus.paragraphMeet")}{" "}
				</p>

				<Link
					to='/BookYourGuide'
					className={Styles.link}
				>
					{t("Aboutus.exploreGuidesPage")}
				</Link>

				<h3 className={isRtl ? Styles.h3Rtl : Styles.h3}>
					{t("Aboutus.titlePlan")}
				</h3>
				<p className={Styles.p}>
					{t("Aboutus.paragraphPlan")}
				</p>

				<HashLink
					smooth
					to='/BookYourGuide/#planyourtip'
					className={Styles.link}
				>
					{t("Aboutus.planyourTripSection")}
				</HashLink>

				<p className={Styles.p}>{t("Aboutus.Final")}</p>
			</div>
		</div>
	);
}

export default AboutUs;
